export const FILE_STORAGE_URL = process.env.REACT_APP_FILE_STORAGE_URL;
export const YOUR_GOOGLE_MAPS_API_KEY = 'AIzaSyBKDeDCyCAHKPru29FgkbODlVNwQGEzDPg';
export const WINDOWS_DOOR_OTHER_OPTION = 'Custom-Other'


export const WINDOWS_DOOR_OTHER_OPTION_VALUE_PREFIX = '_other_value';
export const LOGIN_DEMO_KEY = 'demokey';

export enum API_END_POINT {
    MASTER = "MASTER",
    PARTY = "PARTY",
    ADMIN = "ADMIN",
    ORDER = "ORDERS",
    REPORT ="REPORT",
    PRODUCT="PRODUCT",
    COMMON = "COMMON"
}

export const STORAGE_KEY: {
    [key: string]: {
        CurrentUser: string,
        AuthState: string,
    }
} = {
    scheduler: {
        CurrentUser: 'CURRENT_USER',
        AuthState: 'AUTH_STATE',
    }
}


export enum StorageKey {
    CurrentUser = 'CURRENT_USER',
    AuthState = 'AUTH_STATE',
    UserType = 'USER_TYPE',
    AuthUnion= 'AUTH_UNION',
    UnionId = "UNION_ID",
    Profile="Profile"
}
